import { Box, Chip, lighten, Stack, type SxProps, Typography } from '@mui/material';
import { _ } from '/@/locale';

const dotsColors = ['#075A0E', '#01830C', '#0EA01A', '#13C545', '#FEA55B', '#E56F0F', '#CE630B', '#B85302', '#974401'];

export const References = ({ numberOfDots, sx }: { numberOfDots: number; sx: SxProps }) => {
    return (
        <Stack
            spacing={2}
            sx={{
                overflowX: 'scroll',
                ...sx,
            }}
            width={{ xs: 'auto', md: 'fit-content' }}
        >
            <Typography variant='body2' fontWeight='bold' color='primary'>
                {_('Referencias')}
            </Typography>
            <Stack spacing={1} width='fit-content'>
                <Stack direction='row' spacing={3}>
                    {[...Array(numberOfDots)].map((d, i) => (
                        <Box
                            // biome-ignore lint/suspicious/noArrayIndexKey: false positive
                            key={i}
                            sx={{
                                borderRadius: '100%',
                                background: dotsColors[i],
                                width: '20px',
                                height: '20px',
                                textAlign: 'center',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Typography variant='caption' color='white !important'>
                                {i + 1}
                            </Typography>
                        </Box>
                    ))}
                </Stack>
                <Stack direction='row' justifyContent='space-between'>
                    <Typography variant='body2' color='primary.mui.inactive'>
                        {_('Tolerante')}
                    </Typography>
                    <Typography variant='body2' color='primary.mui.inactive'>
                        {_('Moderado')}
                    </Typography>
                    <Typography variant='body2' color='primary.mui.inactive'>
                        {_('Susceptible')}
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    );
};

export const TextMetricValue = ({ value }: { value: number }) => {
    const sx = ({ color, background }: { color: string; background: string }) => ({
        background,
        '& .MuiChip-label': (t) => ({
            ...t.typography.caption,
            fontWeight: 700,
            color: `${color} !important`,
        }),
        '&:hover': {
            background: lighten(background, 0.3),
        },
    });
    if (value <= 3)
        return <Chip size='small' sx={sx({ background: '#B8F2C7', color: '#084D19' })} label={_('Tolerante')} />;
    if (value <= 6)
        return <Chip size='small' sx={sx({ background: '#FFE4CD', color: '#974401' })} label={_('Moderado')} />;
    return <Chip size='small' sx={sx({ background: '#FFBECE', color: '#443247' })} label={_('Susceptible')} />;
};

const Dots = ({ numberOfDots, selected, sx }: { numberOfDots: number; selected: number; sx: SxProps }) => {
    return (
        <Stack
            spacing={0.5}
            direction='row'
            alignItems='center'
            sx={{
                overflow: 'scroll',
                width: '100%',
                ...sx,
            }}
        >
            {[...Array(numberOfDots + 1)].map((d, i) =>
                selected === i + 1 ? (
                    <Stack
                        // biome-ignore lint/suspicious/noArrayIndexKey: the prop don't change
                        key={i}
                        sx={{
                            borderRadius: '100%',
                            background: dotsColors[i],
                            width: '20px',
                            height: '20px',
                            textAlign: 'center',
                        }}
                        justifyContent='center'
                        alignItems='center'
                    >
                        <Typography
                            variant='caption'
                            color='white !important'
                            sx={{
                                alignContent: 'center',
                            }}
                        >
                            {i + 1}
                        </Typography>
                    </Stack>
                ) : (
                    <Box
                        // biome-ignore lint/suspicious/noArrayIndexKey: false positive
                        key={i}
                        sx={{
                            borderRadius: '100%',
                            background: dotsColors[i],
                            width: '6px',
                            height: '6px',
                        }}
                    />
                )
            )}
        </Stack>
    );
};

export default Dots;
